import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { FreelancerSortModal } from '@pigeons/shared-search-utility/freelancer';
import type {
  AlphabeticalSortOption,
  AllianceCountSortOption,
  FreelancerSortOptionKey,
} from '@pigeons/shared-search-utility/freelancer';
import { Button } from '../common/Button';
import FullBlockingModal from '../common/FullBlockingModal';

const SortModalButton = ({
  className,
  onClick,
  children,
}: {
  className?: string;
  onClick?: () => void;
  children?: ReactNode;
}) => (
  <Button className={className} onClick={onClick}>
    {children ?? null}
  </Button>
);

interface SortModalProps {
  alphabeticalSort: AlphabeticalSortOption;
  allianceCountSort: AllianceCountSortOption;
  className?: string;
  isBlocking?: boolean;
  onClose: () => void;
  setAlphabeticalSort: (sort: AlphabeticalSortOption) => void;
  setAllianceCountSort: (sort: AllianceCountSortOption) => void;
  onSubmit?: () => void;
}

export default function SortModal(props: SortModalProps) {
  const { t } = useTranslation(['freelancers', 'common']);

  const getSortLabel = (option: FreelancerSortOptionKey) =>
    t(`sorts.${option}`, { ns: 'freelancers' });

  return (
    <FreelancerSortModal
      {...props}
      messages={{
        sortBy: t('sortBy', { ns: 'freelancers' }),
        alphabetical: t('alphabetical', {
          ns: 'freelancers',
          defaultValue: 'Classement alphabétique',
        }),
        allianceCount: t('allianceCount', {
          ns: 'freelancers',
          defaultValue: "Classement par nombre d'Alliances",
        }),
        showResults: t('showResults', { ns: 'freelancers' }),
        close: t('common:form_actions.close'),
        getSortLabel,
      }}
      Button={SortModalButton}
      FullBlockingModal={FullBlockingModal}
    />
  );
}
